import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_TRANSACTION_REQUEST,
  ADD_TRANSACTION_SUCCESS,
  ADD_TRANSACTION_FAILURE,
  UPDATE_TRANSACTION_REQUEST,
  UPDATE_TRANSACTION_SUCCESS,
  UPDATE_TRANSACTION_FAILURE,
  DELETE_TRANSACTION_REQUEST,
  DELETE_TRANSACTION_SUCCESS,
  DELETE_TRANSACTION_FAILURE,
} from "../constants/transactionConstant";

export const deleteTransactionAction = (uid) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_TRANSACTION_REQUEST });
    const URL = `${ApiUrl.deleteTransaction}?uid=${uid}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_TRANSACTION_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_TRANSACTION_FAILURE,
      payload: error.response.data,
    });
  }
};